module.exports = __webpack_public_path__ + "static/media/photo91.e00fcc9b.jpg";